import { ITooltipParams } from 'ag-grid-community'

import React, { Fragment, useMemo } from 'react'

import { dealTeams } from '@/constants/dealTeams'
import { useGetStaffUsersQuery } from '@/services/user'

export function DealTeamToolTip(props: ITooltipParams & { color: string }) {
  const { data: staffUsers } = useGetStaffUsersQuery()

  const data = useMemo(() => {
    const { data: rowData } = props.api.getDisplayedRowAtIndex(props.rowIndex)

    return {
      ...rowData,
      deal_teams: rowData.deal_teams?.map((dealTeam) => ({
        type: dealTeam.type,
        user: staffUsers?.find((u) => u.id === dealTeam.user),
      })),
    }
  }, [])

  return (
    <div>
      {data?.deal_teams?.length > 0 ? (
        <ul className='border p-4 rounded bg-white shadow-lg grid grid-cols-2 gap-2'>
          {data?.deal_teams?.map((dt) => (
            <li
              key={dt.user?.id}
              className='flex items-center justify-around text-white px-4 py-2 rounded shadow-md font-semibold'
              style={{ background: dealTeams[dt.type]?.color ?? '#000' }}
            >
              {dt.user?.first_name && dt.user?.last_name ? (
                <Fragment>
                  {dt.user?.first_name} {dt.user?.last_name}
                </Fragment>
              ) : (
                <Fragment>{dt.user?.username}</Fragment>
              )}
              <span className='mx-1'>|</span>
              <span>{dealTeams[dt.type]?.label}</span>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  )
}
